import { useParams } from 'wouter';
import { useMemo } from 'react';

export function useStoreSlug() {
  const { slug } = useParams<{ slug: string }>();

  return useMemo(() => {
    const storedSlug = sessionStorage.getItem('store-slug');

    // Valida se o slug da URL é válido (não undefined, null, vazio ou string "undefined")
    const isValidSlug = slug && slug !== 'undefined' && slug.trim() !== '';

    // Se temos um slug válido na URL, atualiza o storage e retorna
    if (isValidSlug) {
      sessionStorage.setItem('store-slug', slug);
      return { slug };
    }

    // Se não temos slug válido na URL mas temos no storage, retorna o armazenado
    if (storedSlug && storedSlug !== 'undefined') {
      return { slug: storedSlug };
    }

    // Caso não tenha slug válido nem na URL nem no storage
    return { slug: '' };
  }, [slug]);
}
